var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 14v-1h7v2a1 1 0 0 1-1 1H4a2 2 0 0 1-2-2Zm1 0h5v1H4a1 1 0 0 1-1-1ZM22 13v1a2 2 0 0 1-2 2h-4a1 1 0 0 1-1-1v-2h7Zm-6 1h5a1 1 0 0 1-1 1h-4v-1Z",
  fill: "#252829"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1 10h.857L.652 11.099A2 2 0 0 0 0 12.577V22a2 2 0 0 0 2 2h3a1 1 0 0 0 1-1v-3h12v3a1 1 0 0 0 1 1h3a2 2 0 0 0 2-2v-9.423a2 2 0 0 0-.652-1.478L22.143 10H23a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-2.364l-1.74-3.828A2 2 0 0 0 17.076 2H6.924a2 2 0 0 0-1.82 1.172L3.363 7H1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm5.924-7h10.152a1 1 0 0 1 .91.586L20.447 9H3.553l2.46-5.414A1 1 0 0 1 6.925 3ZM17 19h6v-6.423a1 1 0 0 0-.326-.74L20.659 10H3.34l-2.015 1.838a1 1 0 0 0-.326.739V19h6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2Zm-9 0h8a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1Zm15 1v2a1 1 0 0 1-1 1h-3v-3h4ZM5 20H1v2a1 1 0 0 0 1 1h3v-3ZM2.738 8H1v1h1.329l.409-1ZM21.67 9l-.409-1H23v1h-1.329Z",
  fill: "#252829"
})));
export default SvgCarinline;